import React, { useState } from 'react';
import './news.css';

function NewsAndEvent() {
  // Sample news and events data
  const events = [
    {
      id: 1,
      title: 'Up coming CSR Projects!',
      date: '2025-04',
      description: 'Join us in our upcoming Corporate Social Responsibility (CSR) projects, scheduled to take place between February and March 2025. These initiatives are designed to make a meaningful impact on local communities by addressing critical social and environmental challenges. Through collaborative efforts with community members, organizations, and volunteers, we aim to foster sustainable development, promote education, enhance healthcare accessibility, and protect the environment. Whether its planting trees, organizing health camps, or supporting underprivileged groups, our projects are focused on creating positive, lasting change. By participating in these activities, you will have the chance to contribute to meaningful causes while building connections with like-minded individuals who share a passion for making a difference. Stay tuned for detailed project announcements and join us in our mission to inspire hope, empower lives, and build stronger, more resilient communities. Together, we can create a brighter future for everyone.',
      image: 'upcomingcsr.png',
    },
    {
      id: 2,
      title: 'World Eye Sight Day',
      date: '2024-10-10',
      description: 'On October 10, 2024, we proudly celebrated World Eye Sight Day, an event dedicated to raising awareness about the importance of eye health and vision care. The day brought together individuals, healthcare professionals, and organizations to emphasize the critical role of early detection and treatment in preventing vision loss. Through interactive sessions, free eye screenings, and educational workshops, participants gained valuable insights into maintaining healthy vision and recognizing common eye conditions. This years theme highlighted the need for equitable access to eye care services, encouraging communities to come together to support those at risk of vision impairment. The event was a resounding success, with hundreds benefiting from expert consultations and resources designed to promote lifelong eye health. We extend our heartfelt thanks to everyone who participated and contributed to this meaningful cause. Together, we took a step closer to building a world where quality eye care is accessible to all.',
      image: '0002.jpg',
    },
    {
      id: 3,
      title: 'New Arrivals',
      date: '2025-04-01',
      description: 'Discover our latest offerings and innovations launched in January 2025.',
      image: '3.jpg',
    },
  ];

  const [selectedEvent, setSelectedEvent] = useState(null);

  const openPopup = (event) => {
    setSelectedEvent(event);
  };

  const closePopup = () => {
    setSelectedEvent(null);
  };

  return (
    <div className="news-and-event">
      <div className="news-header">
        <h1>News and Events</h1>
        <p>Stay updated with our latest happenings, promotions, and more!</p>
      </div>
      <div className="events-grid">
        {events.map((event) => (
          <div className="event-card" key={event.id}>
            <img src={event.image} alt={event.title} className="event-image" />
            <div className="event-content">
              <h2>{event.title}</h2>
              <p className="event-date">{new Date(event.date).toLocaleDateString()}</p>
              <button className="event-button" onClick={() => openPopup(event)}>
                More Info
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {selectedEvent && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="close-button" onClick={closePopup}>
              &times;
            </button>
            <h2>{selectedEvent.title}</h2>
            <p className="event-date">{new Date(selectedEvent.date).toLocaleDateString()}</p>
            <p>{selectedEvent.description}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default NewsAndEvent;
